<div class="head_section">
  <div class="header_compn_name">{{pageHeading}}</div>
  <div class="border_gra"></div>
</div>